export const iconFontAwesomeMapsScaleUnbalanced = (
	<i className="fa-solid fa-scale-unbalanced"></i>
);
